import { createStore, applyMiddleware, combineReducers } from 'redux';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { reducer as formReducer } from 'redux-form';

export function emptyConfigureStore() {
  const store = createStore(
    combineReducers({ form: formReducer }),
    applyMiddleware(logger)
  );
  return store;
}

export default function configureStore(reducers, saga) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    combineReducers({ ...reducers, form: formReducer }),
    applyMiddleware(
      sagaMiddleware,
      logger
    )
  );
  sagaMiddleware.run(saga);

  return store;
}
